export const LOGIN_USER = 'LOGIN_USER';
export const SERVICE_BY_ID = 'SERVICE_BY_ID';
export const SERVICE_BY_QUERY = 'SERVICE_BY_QUERY';
export const SERVICE_BY_USER = 'SERVICE_BY_USER';
export const NEW_SERVICE = 'NEW_SERVICE';
export const PATCH_SERVICE = 'PATCH_SERVICE';
export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const GET_ALL = 'GET_ALL';
export const CREATE_ACTIVE_SERVICE = 'CREATE_ACTIVE_SERVICE';
export const GET_INFO_BUYER = 'GET_INFO_BUYER';
export const GET_ALL_SERVICES = 'GET_ALL_SERVICES';
export const SERVICE_BY_TITLE = 'SERVICE_BY_TITLE';
export const BOUGHT_SERVICES = 'BOUGHT_SERVICES';
export const GET_SERVICE_BY_USER = 'GET_SERVICE_BY_USER';
